// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6534":"ce99d352","6798":"eb833c85","9339":"eb833c85","9355":"84cdef9c"}[chunkId] + ".chunk.css";
};